import React from 'react';
import { useQueryClient } from 'react-query';
import { Modal, Form, Input } from 'antd';
import useEditRoomDescriptionMutation from '../../../mutations/useEditRoomDescriptionMutation';
import { roomQueryKeys } from '../../../queries/queryKeys';
import { getEditingRoomData } from '../../../utils/getEditingRoomData';
import { stringTrim } from '../../../../../helpers/stringTrim';

const { TextArea } = Input;

const EditRoomDescription = ({ form, onCancel, visible, room }) => {
  const { resetFields, validateFieldsAndScroll, getFieldDecorator } = form;

  const queryClient = useQueryClient();

  const {
    mutateAsync: editDescriptionMutateAsync,
    isLoading: isEditDescriptionLoading,
  } = useEditRoomDescriptionMutation({
    onSuccess: () => queryClient.invalidateQueries(roomQueryKeys(room?.id)),
  });

  const handleCancel = () => {
    resetFields();

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, fieldValues) => {
      if (!err) {
        const data = getEditingRoomData(room);

        await editDescriptionMutateAsync({
          description: stringTrim(fieldValues.description),
          room: data,
        });
        handleCancel();
      }
    });
  };

  const compareToInitialValue = (_rule, value, callback) => {
    if (value && value.trim() === room?.description?.description?.trim()) {
      callback('Описание не изменено');
    } else {
      callback();
    }
  };

  return (
    <Modal
      visible={visible}
      title={
        room?.description?.description
          ? 'Изменить описание'
          : 'Добавить описание'
      }
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText={room?.description?.description ? 'Изменить' : 'Добавить'}
      confirmLoading={isEditDescriptionLoading}
      destroyOnClose
    >
      <Form>
        <Form.Item label="Описание">
          {getFieldDecorator('description', {
            initialValue: room?.description?.description,
            rules: [
              {
                required: true,
                message: 'Введите описание',
                whitespace: true,
              },
              {
                validator: compareToInitialValue,
              },
            ],
          })(<TextArea rows={4} />)}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const EditRoomDescriptionModal = Form.create({ name: 'edit_room_description' })(
  EditRoomDescription
);

export default EditRoomDescriptionModal;
